import _axios from '@/assets/utils/_axios'
import axios from 'axios'
import { _confirm, _alert, _loading } from '../../assets/utils/utils'
import Router from '@/router'
//获取列表数据时，page固定从路由中获取,数据默认获取10条
const NUM = 10;

export default {
  //获取酒店待确认订单列表
  async POST_OrderHotelListConfirmHandle ({ commit, getters }, {data,successFun}) {
     data.store_id=getters.storeInfo.storeId;
      let res = await _axios.post('/pc/Hotel/OrderHotelListConfirmHandle', data);
      if (res.code === '00000') {
        successFun(res.data);
      }
  },
   /*获取订单详情信息*/
  async POST_OrderHotelDetail ({ commit, getters }, {data}) {
      let t = getters.storeInfo.type, url = '';
      switch (t) {
        case 2:
          url = data.flag?'/pc/Visitor/OrderHotelDetail':'/pc/Travel/OrderHotelDetail';
          break
        case 3:
          url = '/pc/Hotel/OrderHotelDetail';
          break
        case 99:
          url = '/pc/Admin/OrderHotelDetail';
          break
      }
      let res = await _axios.post(url, {...data, store_id: getters.storeInfo.storeId});
      if (res.code === '00000') {
        const isObj = (v) => v !== null && typeof v === 'object'&&v.length!=0;
        let room_need_arr=isObj(res.data.info.room_need_arr)?res.data.info.room_need_arr:{list:[],mode:0,num:0,price:0};
        let discount_need_arr=isObj(res.data.info.discount_need_arr)?res.data.info.discount_need_arr:{list:[],mode:0,num:0,price:0};
        //用房与优惠房合并
        discount_need_arr.list.forEach(item => {
            const idx = room_need_arr.list.findIndex(v => v.date === item.date)
            const newOfferList = item.offer_info.map(offer => ({
              ...offer,
              disdRoom: true
            }))
            if (idx > -1) {
              room_need_arr.list[idx].offer_info.push(...newOfferList)
            } else {
              room_need_arr.list.push({
                date: item.date,
                offer_info: newOfferList
              })
            }
        })
        return res.data;
      }
  },
    /*获取上传文件类型*/
  async POST_SendEditReceipt ({ commit, getters }, {data,type,successFun}) {
      let key=['','','send_receipt','offer_receipt']
      data={
          [key[type]]:data.url,
          oid:data.oid
      }
      let url=type==2?'/pc/User/SendEditReceipt':'/pc/User/OfferEditReceipt'
      let res = await _axios.post(url, data);
      if (res.code === '00000') {
        successFun(res.data)
      }
  },
  /*获取上传文件类型*/
  async POST_GetQiNiuFileExt ({ commit, getters }, data) {
      let res = await _axios.post('/pc/AuthAndBind/GetQiNiuFileExt', data);
      if (res.code === '00000') {
        return res.data.info;
      }
  },
  /*修改时·获取酒店房型信息*/
  async POST_HotelsRoomList ({ commit, getters }, data) {
      let res = await _axios.post('/pc/User/GetHotelRoomTitleList', data);
      if (res.code === '00000') {
        commit('UPDATEROOMLIST',res.data.list);
      }
  },
  /*修改时·获取酒店会议室信息*/
  async POST_HotelsMeetingList ({ commit, getters }, data) {
      let res = await _axios.post('/pc/User/GetHotelMeetingTitleList', data);
      if (res.code === '00000') {
        commit('UPDATEMEETINGLIST',res.data.list);
      }
  },
  /*采购商发布订单*/
  async POST_SendOrderHotel ({commit, getters }, {data,successFun}) {
    let res = await _axios.post('/pc/Travel/SendOrderHotel', {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') {
      successFun(res.data)
    }
  },
  /*采购商修改订单*/
  async POST_travelPostOrder ({commit, getters }, data) {
    let url=getters.userInfo.type==2?'/pc/Travel/StartEditOrderHotel':'/pc/Hotel/StartEditOrderHotel'
    let res = await _axios.post(url, {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    return res
  },
  /*发布确认订单*/
  async POST_SendOrderHotelConfirm ({commit, getters }, {data,modify,successFun}) {
    let url=modify?'/pc/User/EditOrderHotelConfirm':'/pc/User/SendOrderHotelConfirm'
    let res = await _axios.post(url, {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') {
      successFun(res.data)
    }
  },
   /*同意修改订单*/
  async POST_EditOrderHotel ({ dispatch,commit, getters }, {data,successFun}) {
    let t = getters.storeInfo.type, url = '';
    switch (t) {
        case 2:
          url = '/pc/Travel/EndEditOrderHotel';
          break
        case 3:
          url = '/pc/Hotel/EndEditOrderHotel';
          break
    }
    let res = await _axios.post(url, {
        store_id: getters.isGroup ? Router.currentRoute.query.store : getters.storeInfo.storeId,
        ...data
    });
    if (res.code === '00000') {
      successFun()
    }
  },
    /*采购商同意确认订单*/
  async POST_DealOrderHotelConfirm ({ commit, getters },{oid,successFun}) {
    let res = await _axios.post('/pc/User/DealOrderHotelConfirm', {
      store_id: getters.storeInfo.storeId,
      oid
    });
    if (res.code === '00000') successFun();
  },
  /*采购商拒绝确认订单*/
  async POST_RefuseOrderHotelConfirm ({ commit, getters },{data,successFun}) {
    let res = await _axios.post('/pc/User/RefuseOrderHotelConfirm', {
      store_id: getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') successFun();
  },
  /*采购商设置代订收款*/
  async POST_SetOrderHotelBroker ({commit, getters }, data) {
    let res = await _axios.post('/pc/Travel/SetOrderHotelBroker', {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    return res
  },
    /*采购商设置代订收款*/
  async POST_SetOrderHotelBroker ({commit, getters }, data) {
    let res = await _axios.post('/pc/Travel/SetOrderHotelBroker', {
      store_id:getters.storeInfo.storeId,
      ...data
    });
    return res
  },
  //计算订单总金额
  async POST_ComputeOrderHotelPrice ({ commit, getters }, data) {
      const res = await _axios.post('/pc/Visitor/ComputeOrderHotelPrice',data);
      if(res.code=="00000"){
          return res.data.info
      }
  },
  //供应商添加导游列表获取
  async  POST_GuideList ({ commit, getters }, data){
      let src=data.tab==1?'/pc/Travel/GuideList':'/pc/Travel/LeaderList'
      const res = await _axios.post(src,data);
      if(res.code=="00000"){
        return res.data
      }
  },
  //旅行社添加核房人、支付人
  async  POST_OrderHotelSetVerify ({ commit, getters }, {data,tab}){
      let src=tab==1?'/pc/Travel/OrderHotelSetVerify':'/pc/Travel/OrderHotelSetPay'
      const res = await _axios.post(src,data);
      return res
  },
  //供应商添加导游列表获取
  async  POST_AddGuide ({ commit, getters }, {data,tab}){
      let src=tab==1?'/pc/Travel/AddGuide':'/pc/Travel/AddLeader'
      const res = await _axios.post(src,{...data,store_id:getters.storeInfo.storeId});
      return res
  },
  //旅行社-删除(核房人/支付人)
  async  POST_OrderHotelDelPay ({ commit, getters }, {data,tab}){
       let src=tab==1?'/pc/Travel/OrderHotelDelVerify':'/pc/Travel/OrderHotelDelPay'
      const res = await _axios.post(src,{...data,store_id:getters.storeInfo.storeId});
      return res
  },
  //旅行社-修改人员名单名称
  async  POST_OrderHotelRenameTrip ({ commit, getters }, {data}){
      const res = await _axios.post('/pc/Travel/OrderHotelRenameTrip',{...data,store_id:getters.storeInfo.storeId});
      if(res.code=="00000"){
        return res
      }
  },
  /*确认单分享二维码*/
  async POST_GetOrderDetailQRCode({ commit, getters},{data,flag,successFun}) {
      let res = await _axios.post('/pc/WechatApplet/GetOrderDetailQRCode', {...data,store_id:getters.storeInfo.storeId,flag});
      if (res.code === '00000') successFun(res.data);
  },
  /*修改订单金额*/
  async POST_EditOrderHotelDeposit({ commit, getters},{data,successFun}) {
      let res = await _axios.post('/pc/User/EditOrderHotelDeposit', {...data,store_id:getters.storeInfo.storeId});
      if (res.code === '00000') successFun(res.data);
  },
  /*修改销售职位*/
  async POST_SetUserStorePositionName({commit, getters},{data,successFun}) {
       console.log(getters);
    _confirm('确定修改该职位吗？',async () => {
      if(getters.storeInfo.level==3){
        data.uid=getters.uid
      };
      let res = await _axios.post('/pc/User/SetUserStorePositionName', {...data});
      if (res.code === '00000') successFun(res.data);
    })
  },
  /*已成交取消订单*/
  async POST_StartCancelOrderHotel ({getters},{data,successFun}) {
    let t = getters.storeInfo.type, url = '';
    switch (t) {
        case 2:
          url = '/pc/Travel/StartCancelOrderHotel';
          break
        case 3:
          url = '/pc/Hotel/StartCancelOrderHotel';
          break
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') successFun();
  },
  /*撤销取消订单*/
  async POST_RevokeCancelOrderHotel ({getters},{data,successFun}) {
    let t = getters.storeInfo.type, url = '';
    switch (t) {
        case 2:
          url = '/pc/Travel/RevokeCancelOrderHotel';
          break
        case 3:
          url = '/pc/Hotel/RevokeCancelOrderHotel';
          break
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') successFun();
  },
  /*确认取消订单*/
  async POST_EndCancelOrderHotel ({getters},{data,successFun}) {
    let t = getters.storeInfo.type, url = '';
    switch (t) {
        case 2:
          url = '/pc/Travel/EndCancelOrderHotel';
          break
        case 3:
          url = '/pc/Hotel/EndCancelOrderHotel';
          break
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') successFun();
  },
  /*置顶某一条房间会议室*/
  async POST_TopOrderHotel ({getters},{id,type,successFun}) {
    let url = '',data={};
    switch (type) {
        case 1:
          url = '/pc/User/RoomTop';
          data.room_id=id
          break
        case 2:
          url = '/pc/User/MeetingTop';
          data.meeting_id=id
          break
    }
    let res = await _axios.post(url, {
      store_id: getters.storeInfo.storeId,
      ...data
    });
    if (res.code === '00000') successFun();
  },
   //历史报价
  async POST_HistoryOfferHotel({commit, getters},{data,successFun}) {
      let res = await _axios.post('/pc/Travel/HistoryOfferHotel', {...data});
      if (res.code === '00000'){
        successFun(res.data)
      }
  },
  //历史报价销售
  async POST_HistoryOfferHotelSale({commit, getters},{data,successFun}) {
      let url='/pc/Travel/HistoryOfferHotelSale'
      if(data.offer_uid){
        url='/pc/Travel/HistoryOfferHotelOfferList'
      }
      let res = await _axios.post(url, {...data});
      if (res.code === '00000'){
        successFun(res.data)
      }

  },
  //历史报价图表
  async POST_HistoryOfferHotelOfferList({commit, getters},{data,successFun}) { 
      let res = await _axios.post('/pc/Travel/HistoryOfferHotelOfferList365', {...data});
      if (res.code === '00000'){
        successFun(res.data)
      }
  },
  //酒店详情
  async POST_HotelDetail({commit, getters},{data,successFun}) {
      let res = await _axios.post('/pc/Home/HotelDetail', {...data});
      if (res.code === '00000'){
        successFun(res.data.info)
      }
  },
  //订单详情报价列表
  async POST_Quotation_OrderHotelDetail({commit, getters},{data,successFun}) {
    let t = getters.storeInfo.type, url = '';
      switch (t) {
        case 2:
          url = '/pc/Travel/OrderHotelDetail';
          break
        case 99:
          url = '/pc/Admin/OrderHotelDetail';
          break
      }
      let res = await _axios.post(url, {num:NUM,...data});
      if (res.code === '00000'){
        successFun(res.data.offer)
      }
  },
  //上传发票列表
  async POST_OrderHotelReceiptList({commit, getters},{data,successFun}) {
    let t = getters.storeInfo.type, url = '';
      switch (t) {
        case 2:
          url = '/pc/Travel/OrderHotelReceiptList';
          break
        case 3:
          url = '/pc/Hotel/OrderHotelReceiptList';
          break
      }
      let res = await _axios.post(url, {store_id: getters.storeInfo.storeId,num:NUM,...data});
      if (res.code === '00000'){
        successFun(res.data)
      }
  },
  //询价中-待报价订单列表
  async POST_InquiryList({commit, getters},{data,successFun}) {
      let t = getters.storeInfo.type, url = '';
      switch (t) {
        case 2:
          url = '/pc/Travel/OrderHotelList';
          break
        case 3:
          url = '/pc/Hotel/HotelOfferList';
          break
        case 99:
          url = '/pc/Admin/OrderHotelList';
          break
      }
      let res = await _axios.post(url, {...data});
      if (res.code === '00000'){
        successFun(res.data)
      }
  },
    /*酒店待报价/管理员待处理订单列表*/
  async POST_OrderHotelList ({ commit, getters },  {data,successFun}) {
    let url = '';
    switch (getters.storeInfo.type) {
      case 2:
        url = data.status=='66'?'/pc/Travel/RecycleOrderHotelList':'/pc/Travel/OrderHotelList'; 
      break;
      case 3:
        url = '/pc/Hotel/OrderHotelList'; 
      break;
      case 99:
        url = '/pc/Admin/OrderHotelList'; 
      break;
    }
    if(data.status=='66'){
      data={
        page:data.page,
        num:data.num,
      }
    }
    data.store_id = getters.storeInfo.storeId;
    let res = await _axios.post(url, data)
    if (res.code === '00000' || res.code === '99999') {
      successFun(res.data);
    }
  },
  /*确认订单列表*/
  async POST_OrderHotelListConfirm ({ commit, getters },  {data,successFun}) {
        let url = '';
    switch (getters.storeInfo.type) {
      case 2:
        url = '/pc/Travel/OrderHotelListConfirm'; 
      break;
      case 3:
        url = '/pc/Hotel/OrderHotelListConfirm'; 
      break;
      case 99:
        url = '/pc/Admin/OrderHotelConfirmingList'; 
      break;
    }
    data.store_id = getters.storeInfo.storeId;
    let res = await _axios.post(url, data)
    if (res.code === '00000' || res.code === '99999') {
      successFun(res.data);
    }
  },
      /*确认订单列表*/
    async POST_Admin_OrderHotelPendingList ({ commit, getters },  {data,successFun}) {
      data.store_id = getters.storeInfo.storeId;
      let res = await _axios.post('/pc/Admin/OrderHotelPendingList', data)
      if (res.code === '00000' || res.code === '99999') {
        successFun(res.data);
      }
    },
    /*还原订单*/
    async POST_RestoreOrder ({getters},{oid,switchs,successFun}) {
      let t = getters.storeInfo.type, url = '',data;
      switch (t) {
        case 2:
          url = switchs==1?'/pc/Travel/BatchRestoreDelOrderHotel':'/pc/Travel/RestoreOrderHotel';
          data={
            [switchs==1?'oid_list':'oid']: oid
          }
          break
        case 3:
          url = switchs==1?'/pc/Hotel/BatchRestoreDelOrderHotel':'/pc/Hotel/RestoreOrderHotel';
          data={
            [switchs==1?'hoid_list':'hoid']: oid
          }
          break
      }
      let res = await _axios.post(url, {
        ...data,
        store_id: getters.storeInfo.storeId,
      });
      if (res.code === '00000') successFun();
    },
    //企业审核打款列表
    async POST_PaymentVerifyList({commit, getters},{data,successFun}) {
        let url = '';
        data.store_id = getters.storeInfo.storeId;
        switch (getters.storeInfo.type) {
          case 2:
            url = '/pc/Travel/PaymentVerifyList'; 
          break;
          case 99:
            url = '/pc/Admin/PaymentEnterprisePendingList'; 
          break;
        }
        let res = await _axios.post(url, {...data});
        if (res.code === '00000'){
          successFun(res.data)
        }
    },
    //企业审核打款信息
    async POST_VerifyFinance({commit, getters},{data,successFun}) {
        let res = await _axios.post('/pc/Travel/VerifyFinance', {...data});
        if (res.code === '00000'){
          successFun(res.data)
        }
    },
    //用户身份认证列表
    async POST_RealVerifyList({commit, getters},{data,successFun}) {
      let url = '';
        switch (getters.storeInfo.type) {
          case 2:
          case 3:
            url = '/pc/User/RealVerifyList'; 
          break;
          case 99:
            url = '/pc/Admin/RealVerifyList'; 
          break;
        }
        let res = await _axios.post(url, {...data});
        if (res.code === '00000'){
          successFun(res.data)
        }
    },
    //提交身份认证
    async POST_RealVerifySubmit({commit, getters},{data,successFun}) {
        let res = await _axios.post('/pc/User/RealVerifySubmit', {...data});
        if (res.code === '00000'){
          successFun()
        }
    },
    //审核用户身份认证信息
    async POST_RealVerify({commit, getters},{data,successFun}) {
        let res = await _axios.post('/pc/Admin/RealVerify', {...data});
        if (res.code === '00000'){
          successFun(res.data)
        }
    },
    //用户身份认证信息
    async POST_RealVerifyInfo({commit, getters},{data,successFun}) {
        let res = await _axios.post('/pc/Admin/RealVerifyInfo', {...data});
        if (res.code === '00000'){
          successFun(res.data)
        }
    },
  }